var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#FF3344"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9671 38.8888C70.5405 38.3052 70.5405 37.3698 69.9671 36.7862L66.3338 33.0883C65.7459 32.49 64.7817 32.49 64.1938 33.0883L52.3344 45.1586C51.7466 45.7569 50.7824 45.7569 50.1945 45.1586L38.8057 33.5672C38.2178 32.9689 37.2536 32.9689 36.6657 33.5672L33.0324 37.2651C32.459 37.8487 32.459 38.7841 33.0324 39.3677L44.4954 51.0346C45.0688 51.6181 45.0688 52.5535 44.4954 53.1371L34.1837 63.6322C33.6104 64.2157 33.6103 65.1511 34.1837 65.7347L37.817 69.4327C38.4049 70.031 39.3691 70.031 39.957 69.4327L50.1945 59.013C50.7824 58.4147 51.7466 58.4147 52.3344 59.013L63.0425 69.9116C63.6304 70.5099 64.5946 70.5099 65.1824 69.9116L68.8158 66.2136C69.3891 65.6301 69.3891 64.6947 68.8158 64.1111L58.0336 53.1371C57.4602 52.5535 57.4602 51.6181 58.0336 51.0346L69.9671 38.8888Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewError);
export default __webpack_public_path__ + "static/media/new-error.c605812611c9d345215186662434b45b.svg";
export { ForwardRef as ReactComponent };